"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function resolvePlayableStreams(mediaStreams, playableStreamCreators, emit) {
    var playableStreams = [];
    var groupedStreams = groupStreamsByMediaType(mediaStreams);
    Object.keys(groupedStreams).forEach(function (mediaType) {
        var mediaStreams = groupedStreams[mediaType];
        for (var i = 0; i < playableStreamCreators.length; ++i) {
            var playableStreamCreator = playableStreamCreators[i];
            if (playableStreamCreator.canPlay(mediaType)) {
                playableStreams.push(new playableStreamCreator(mediaStreams, emit));
                break;
            }
        }
        ;
    });
    playableStreams.sort(function (firstStream, secondStream) {
        return secondStream.getMediaStreamDeliveryType() - firstStream.getMediaStreamDeliveryType();
    });
    return playableStreams;
}
exports.resolvePlayableStreams = resolvePlayableStreams;
function groupStreamsByMediaType(mediaStreams) {
    var typeMap = {};
    mediaStreams.forEach(function (mediaStream) {
        var currentValue = typeMap[mediaStream.type];
        if (!Array.isArray(typeMap[mediaStream.type])) {
            typeMap[mediaStream.type] = [];
        }
        typeMap[mediaStream.type].push(mediaStream);
    });
    return typeMap;
}
//# sourceMappingURL=playback-resolution.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/media-streams/playback-resolution.js
// module id = 1517
// module chunks = 0 1 2 3